export default __webpack_public_path__ + "static/media/taster days brochure.40019f30.pdf";